import { FormEvent } from "react";
import { Button, TextField } from "@mui/material";
import "./Login.scss";
import { Link } from "react-router-dom";
import { ChangeEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "./../../store/reducers/authReducer";

const Login = () => {

  const [user, setUser] = useState({email:"", password:""});
  const dispatch = useDispatch();

  const handleLogin = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

     fetch(`${process.env.REACT_APP_API_URL}/login`, {
      method:'POST',
      headers:{
        "Content-Type":"application/json"
      },
      body:JSON.stringify(user)
    })
    .then((response) => {
      if(!response.ok){
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json();
    })
    .then(data => {
      const token = data.token;
      localStorage.setItem('token', token);
      dispatch(authActions.setInitialUrl('/dashboard'))
      dispatch(authActions.isAuthenticated(true));

    })

  } 

  const handleInput = (e:ChangeEvent<HTMLInputElement>) => {
    const field = e.target.type;

    setUser(user => {return {...user, [field]:e.target.value}})

  }

  return (
    <>
      <div id="login-page-container" className="page-container">
        <form onSubmit={handleLogin}>
          <div className="login-wrapper">
            <div className="login-text">
              Login to Heritage App CMS
            </div>
            <TextField
              className="text-field"
              label="Email"
              variant="outlined"
              type="email"
              value={user.email}
              onChange={handleInput}
              required />
            <TextField
              className="text-field"
              label="Password"
              variant="outlined"
              type="password"
              value={user.password}
              onChange={handleInput}
              required />
            <div>
              <Link to={'/forgot-password'}>Forgot password? </Link>
            </div>
            <Button className="btn-login" variant="contained" type="submit">Login</Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
